import { useRef, useEffect } from 'react'
import styles from './OEmbed.module.scss'

// toDo: löschen?!

const OEmbed = ({ url }: { url: string }) => {
  const API = 'https://embeds.rtl.de/oembed'
  const elem = useRef<HTMLDivElement>(null)

  useEffect(() => {
    fetch(API + '?url=' + url, {
      signal: AbortSignal.timeout(60000),
    })
      .then((response) => response.text())
      .then((txt) => {
        const data = JSON.parse(txt)
        if (data.html && elem.current) {
          elem.current.prepend(document.createRange().createContextualFragment(data.html))
        }
      })
      .catch((error) => {
        console.error(error)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div className={styles.wrapper} ref={elem}></div>
}

export default OEmbed
